import { Text } from '@chakra-ui/react';
import React from 'react';
import { ESPACAMENTO } from './constantes';

const AvisoSemColecao: React.FC = () => (
  <Text fontSize="xs" color="orange.500" px={`${ESPACAMENTO}px`} mt={2}>
    Nenhuma coleção selecionada — a vitrine ficará vazia no app.
  </Text>
);

export default AvisoSemColecao;
